import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp, query, onSnapshot, orderBy, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import '../Admin.css';

// വസ്ത്രങ്ങളുടെയും മറ്റ് ഐറ്റങ്ങളുടെയും ഐക്കൺ ലിസ്റ്റ്
const itemIcons = [
  { icon: 'fas fa-tshirt', label: 'Shirt tshirt' },
  { icon: 'fas fa-user-tie', label: 'Formal Shirt' },
  { icon: 'fas fa-socks', label: 'Socks' },
  { icon: 'fas fa-hat-cowboy', label: 'Cap Hat' },
  { icon: 'fas fa-person-dress', label: 'Saree Blouse Dress' },
  { icon: 'fas fa-vest', label: 'Kanthora Arabic' },
  { icon: 'fas fa-couch', label: 'Sofa' },
  { icon: 'fas fa-scroll', label: 'Curtain' },
  { icon: 'fas fa-boot', label: 'Shoe' },
  { icon: 'fas fa-bed', label: 'Bed Sheet Blanket' },
  { icon: 'fas fa-briefcase', label: 'Bag' },
  { icon: 'fas fa-mitten', label: 'Gloves' }
];

function Items() {
  const [itemName, setItemName] = useState('');
  const [selectedService, setSelectedService] = useState('');
  const [selectedIcon, setSelectedIcon] = useState(itemIcons[0].icon);
  const [actualPrice, setActualPrice] = useState('');
  const [offerPrice, setOfferPrice] = useState('');
  
  const [services, setServices] = useState([]); // Services from DB
  const [items, setItems] = useState([]); // Items from DB
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [iconSearchTerm, setIconSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);

  // Fetch Services & Items
  useEffect(() => {
    // Get Services for Dropdown
    const qServices = query(collection(db, "services"), orderBy("createdAt", "asc"));
    const unsubServices = onSnapshot(qServices, (snapshot) => {
      setServices(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    // Get Items for Table
    const qItems = query(collection(db, "items"), orderBy("createdAt", "desc"));
    const unsubItems = onSnapshot(qItems, (snapshot) => {
      setItems(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    return () => { unsubServices(); unsubItems(); };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedService) return alert("Please select a service!");
    
    setLoading(true);
    const itemData = {
      name: itemName,
      serviceId: selectedService,
      serviceName: services.find(s => s.id === selectedService)?.name || '',
      icon: selectedIcon,
      actualPrice: Number(actualPrice),
      offerPrice: Number(offerPrice),
      updatedAt: serverTimestamp()
    };

    try {
      if (editId) {
        await updateDoc(doc(db, "items", editId), itemData);
        setEditId(null);
      } else {
        await addDoc(collection(db, "items"), { ...itemData, createdAt: serverTimestamp() });
      }
      resetForm();
    } catch (error) { console.error(error); }
    setLoading(false);
  };

  const resetForm = () => {
    setItemName(''); setActualPrice(''); setOfferPrice('');
    setEditId(null); setSelectedService('');
  };

  const handleEdit = (item) => {
    setEditId(item.id);
    setItemName(item.name);
    setSelectedService(item.serviceId);
    setSelectedIcon(item.icon);
    setActualPrice(item.actualPrice);
    setOfferPrice(item.offerPrice);
    window.scrollTo(0,0);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this item?")) await deleteDoc(doc(db, "items", id));
  };

  const filteredIcons = itemIcons.filter(i => i.label.toLowerCase().includes(iconSearchTerm.toLowerCase()));

  return (
    <div className="add-services-container">
      <section className="form-section">
        <div className="form-card-full">
          <h3>{editId ? 'Edit Item' : 'Add New Item'}</h3>
          <form onSubmit={handleSubmit} className="horizontal-form">
            <div className="form-row">
              <div className="input-group">
                <label>Item Name</label>
                <input type="text" value={itemName} onChange={(e)=>setItemName(e.target.value)} placeholder="Shirt, Saree..." required />
              </div>

              <div className="input-group">
                <label>Service</label>
                <select value={selectedService} onChange={(e)=>setSelectedService(e.target.value)} required>
                  <option value="">Select Service</option>
                  {services.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                </select>
              </div>

              <div className="input-group">
                <label>Icon</label>
                <div className="icon-trigger-fancy" onClick={() => setIsModalOpen(true)}>
                  <i className={selectedIcon}></i>
                  <span>Pick</span>
                </div>
              </div>

              <div className="input-group">
                <label>Actual ₹</label>
                <input type="number" value={actualPrice} onChange={(e)=>setActualPrice(e.target.value)} required />
              </div>

              <div className="input-group">
                <label>Offer ₹</label>
                <input type="number" value={offerPrice} onChange={(e)=>setOfferPrice(e.target.value)} required />
              </div>
                <button type="submit" className="submit-btn" disabled={loading}>
  {loading ? (editId ? 'Updating...' : 'Adding...') : (editId ? 'Update Item' : 'Add Item')}
</button>
              {editId && <button onClick={resetForm} className="cancel-btn">Cancel</button>}
            </div>
          </form>
        </div>
      </section>

      <section className="table-section">
        <div className="table-card">
          <table className="modern-admin-table">
            <thead>
              <tr>
                <th>Sl</th>
                <th>Icon</th>
                <th>Item Name</th>
                <th>Service</th>
                <th>Price</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td><div className="table-icon-circle"><i className={item.icon}></i></div></td>
                  <td><strong>{item.name}</strong></td>
                  <td><span className="service-tag">{item.serviceName}</span></td>
                  <td><span className="price-new">₹{item.offerPrice}</span> <small className="price-old">₹{item.actualPrice}</small></td>
                  <td>
                    <button onClick={() => handleEdit(item)} className="edit-btn"><i className="fas fa-edit"></i></button>
                    <button onClick={() => handleDelete(item.id)} className="delete-action-btn"><i className="fas fa-trash"></i></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Icon Popup */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modern-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-search">
              <input type="text" placeholder="Search icon..." onChange={e => setIconSearchTerm(e.target.value)} autoFocus />
            </div>
            <div className="icon-grid-scrollable">
              {filteredIcons.map((item, idx) => (
                <div key={idx} className="icon-grid-item" onClick={() => { setSelectedIcon(item.icon); setIsModalOpen(false); }}>
                  <i className={item.icon}></i>
                  <span>{item.label.split(' ')[0]}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Items;